<template>
  <div class="news-widget-component">
    <div class="area">
      <div
        class="row news-widget-container"
        v-animated-show="utils.handleScroll"
      >
        <div class="row-offset">
          <h2 v-html="info.title" class="col-5 gap-offset"></h2>
          <div class="col-5 col-md-12 gap-offset">
            <div class="news-list">
              <section
                class="list-section-banner"
                v-for="(l, i) in list"
                :key="i"
              >
                <div class="content">
                  <router-link class="description-link" :to="l.href">
                    <Description
                      class="mini icon-top icon-top-small"
                      :isMoreTop="true"
                      ref="bannerDescription"
                      :title="l.title"
                      :more="l.date"
                      :href="l.href"
                      :icon="l.icon"
                      v-if="l.title"
                    />
                  </router-link>
                </div>
              </section>
            </div>
            <div v-if="info.button" class="button-container">
              <a
                :href="info.href"
                :url="info.href"
                class="button"
                :class="[{ inverse: isInverse }]"
                >{{ info.button }}</a
              >
            </div>
          </div>
          <div class="art col-5 col-md-12"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
export default {
  name: "NewsWidget",
  props: {
    isInverse: Boolean,
    info: Object,
    list: Array,
  },
  data() {
    return { utils: utils };
  },
};
</script>

<style lang="scss">
.news-widget-component {
  @extend %page-block;
  @media all and (max-width: $md) {
    padding-bottom: 42px;
  }
  padding-bottom: 80px;
  .row-offset {
    @media all and (max-width: $md) {
      grid-gap: 26px;
    }
  }
  h2 {
    @media all and (max-width: $md) {
      margin-bottom: 0px;
    }
    margin-bottom: 35px;
  }
  .button {
    margin-top: 42px;
    @extend %button-more;
  }

  .description-link {
    .title {
      transition: color 0.5s;
    }
    &:hover {
      .title {
        color: $color-accent;
      }
    }
  }
  .news-list {
    display: grid;
    grid-gap: 36px;
  }
  .art {
    @media all and (max-width: $md) {
      grid-row: 2;
      grid-column: 1 / span 12;
      mask-size: contain;
      background-size: cover;
      height: 100vw;
      max-height: 360px;
    }
    margin-top: -26px;
    grid-row: 1 / span 2;
    grid-column: 6 / span 5;
    background: url(../assets/photos/main/news@2x.png) center center no-repeat;
    background-size: cover;
    -webkit-mask: url(../assets/photos/main/recepit_mask.svg) center center
      no-repeat;
    mask: url(../assets/photos/main/recepit_mask.svg) center center no-repeat;
    mask-size: contain;
  }
}
</style>
